import Phaser from "phaser";
import { messages } from "@/game/data/messages";
import { SceneKeys } from "@/game/data/scene-keys";

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super(SceneKeys.Preload);
  }

  create(): void {
    const { width, height } = this.scale;
    this.add
      .text(width / 2, height / 2, messages.loading, {
        fontFamily: "system-ui, sans-serif",
        fontSize: "20px",
        color: "#e8eef5",
      })
      .setOrigin(0.5);

    this.time.delayedCall(200, () => {
      const next =
        (this.registry.get("startSceneKey") as string | undefined) ?? SceneKeys.Game;
      this.scene.start(next);
    });
  }
}
